var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.5C22.953 2.867 25.667 2.833 26 3v17h-6.5c0-5 0-8.5 2-13.5zM5 8h10v1A5 5 0 015 9V8z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.933 2.784c1.698-1.231 3.21-.791 3.378-.734A1 1 0 0127 3v27h-2V3.98c-.27.064-.604.201-.96.475-1.313 1.005-3.488 4.258-3.617 14.758h2.589v2h-3.596a1 1 0 01-1-1c0-9.392 1.52-15.255 4.517-17.429zM11.124 14.641c2.901-.48 5.123-3 5.123-6.034V2h-2v6.607a4.128 4.128 0 01-4.123 4.123A4.128 4.128 0 016 8.607V2H4v6.607c0 3.035 2.222 5.555 5.124 6.034V30h2V14.64zM9.416 9.76a1 1 0 11-2 0V2h2v7.76zm3.416 0a1 1 0 11-2 0V2h2v7.76z",
    fill: props.color
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 21h8v8h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.242 20.757a6 6 0 10-8.486 8.487 6 6 0 008.486-8.487zM23.714 28l-2.384-2.384 1.212-1.212 1.172 1.172 3.532-3.532 1.212 1.212L23.714 28z",
    fill: "#54822B"
  })));
}

export default SvgIconCovidMeal;